import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import History from '../views/History.vue'
import { auth } from '@/firebase/firebaseConfig'
import store from '@/store'
import Assignments from '../views/Assignments.vue'
import Shipments from '../views/Shipments.vue'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login')
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      auth: true
    }
  },
  {
    path: '/assignments',
    name: 'assignments',
    component: Assignments,
    meta: {
      auth: true
    }
  },
  {
    path: '/shipments',
    name: 'shipments',
    component: Shipments,
    meta: {
      auth: true
    }
  },
  {
    path: '/history',
    name: 'history',
    component: History,
    meta: {
      auth: true
    }
  },
  {
    path: '/reports/delivery',
    name: 'deliveryReport',
    component: () => import('../views/reports/DeliveryReport.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/cotizador',
    name: 'shippingCalculator',
    component: () => import('../views/ShippingCalculator.vue'),
    meta: {
      auth: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  auth.onAuthStateChanged(async () => {
    // get firebase current user
    const firebaseCurrentUser = auth.currentUser
    if (!store.state.user.id && firebaseCurrentUser) {
      await store.dispatch('setUser')
    }
    console.log(to.name)
    console.log(store.state.user)
    // If auth required, check login. If login fails redirect to login page
    if (to.meta.auth) {
      if (!(firebaseCurrentUser)) {
        store.dispatch('showLogin')
        return next('/login')
      } else {
        if (to.name === 'home' && store.state.user.role.value === 'dealer') {
          store.dispatch('hideLogin')
          return next('/shipments')
        } else {
          store.dispatch('hideLogin')
          return next()
        }
      }
    } else {
      return next()
    }
  })
})

export default router
